import jssVariables from "../../jss_setup";

export const footer = {
  footer: {
    background: "black",
  },
  logo: {
    justifySelf: "baseline",
    height: `calc(${jssVariables.navbar_height} / 2.3)`,
    marginBottom: "3rem",
  },
  group: {
    gridTemplateColumns: "1fr",
    fontSize: "small",
    smallscreen: {
      gridTemplateColumns: "1fr",
    },
  },
  emptyIconSpace: {
    display: "none",
  },
  groupIcon: {
    display: "none",
  },
  socialMediaIcon: {
    display: "block",
  },
  socialMediaLabel: {
    display: "none",
  },
  socialMediaGroup: {
    display: "none",
    background: jssVariables.colors.base_color,
    width: "2.5rem",
    height: "2.5rem",
    placeItems: "center",
    borderRadius: jssVariables.half_gap,
  },
  sectionSocialMedia: {
    gridAutoFlow: "column",
    gridTemplateRows: "max-content max-content",
  },
  sectionSocialMediaTitle: {
    display: "none",
  },
};
